module.exports = __webpack_public_path__ + "img/QR1.24ee3124.jpg";